import {FC, useEffect, useState} from "react";
import {Grid, TextField, Tooltip} from "@material-ui/core";
import * as React from "react";
import {NimbleTokenData} from "./types/nimbleTokenData";
import {set} from "react-hook-form";


interface Props {
    nimble_token: NimbleTokenData;
    nimble_key : string ;
    window : string;
}

const NimbleToken : FC<Props> = ({nimble_token , nimble_key , window}) => {

    const [key , setKey] = React.useState<any>('');
    const [nimble_window , setWindow] = React.useState<any>('');

    useEffect( ()=> {
        nimble_token(JSON.stringify({"key" : key , "window" : nimble_window}))
    },[key, nimble_window])

    useEffect(() => {
        if (nimble_key && window){
            setKey(nimble_key)
            setWindow(window)
        }

    }, [nimble_key, window])

    return(
        <>
            <Grid item md={3}>
                <Tooltip title="The key needed to generate the nimble token for stream protection" placement='top-end' aria-multiline>
                    <TextField
                        placeholder="Nimble Key"
                        variant="outlined"
                        name="key"
                        value={nimble_key}
                        fullWidth
                        onChange={e => {setKey(e.target.value)}}
                    />
                </Tooltip>
            </Grid>
            <Grid item md={3}>
                <Tooltip title="Time in minutes of validity" placement='top-end' aria-multiline>
                    <TextField
                        placeholder="Window"
                        variant="outlined"
                        name='window'
                        value={window}
                        fullWidth
                        onChange={e => {setWindow(e.target.value)}}
                    />
                </Tooltip>
            </Grid>
        </>

    )
}




export default NimbleToken;